import React, { createContext, FC, useContext } from 'react'
import { Meta } from 'restful-react/dist/Get'
import { PollState } from 'restful-react/dist/Poll'
import { PollGetKeepTruckinLocations } from '../components/fleet-view/PollTruckLocations'
import { KeepTruckinTruckLocationsResponse } from '../types'

/**
 * 30 seconds interval
 */
const INTERVAL_MS = 30000

export interface ITruckLocationsContext {
  data: KeepTruckinTruckLocationsResponse | null
  states: Pick<
    PollState<KeepTruckinTruckLocationsResponse, unknown>,
    'loading' | 'polling' | 'finished' | 'error'
  >
  actions: {
    start: () => void
    stop: () => void
  }
  meta: Meta
}

export const TruckLocationsContext = createContext<ITruckLocationsContext>({
  data: null,
  states: {
    loading: false,
    polling: false,
    finished: false,
    error: null,
  },
  actions: {
    start: () => {},
    stop: () => {},
  },
  meta: {
    response: null,
    absolutePath: '',
  },
})

export const TruckLocationsPollProvider: FC = ({ children }) => {
  return (
    <PollGetKeepTruckinLocations interval={INTERVAL_MS} lazy>
      {(data, states, actions, meta) => {
        return (
          <TruckLocationsContext.Provider value={{ data, states, actions, meta }}>
            {children}
          </TruckLocationsContext.Provider>
        )
      }}
    </PollGetKeepTruckinLocations>
  )
}

export const useTruckLocationsContext = () =>
  useContext<ITruckLocationsContext>(TruckLocationsContext)
